// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared absolute overlay for loading states inside positioned containers. */
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.loading-overlay--light {
  background: rgba(255, 255, 255, 0.92);
}

.loading-overlay--soft {
  background: rgba(255, 255, 255, 0.82);
}

.loading-overlay--dark {
  background: rgba(15, 23, 42, 0.55);
}

.loading-overlay--dark ::ng-deep .loading-indicator {
  color: #f8fafc;
}

.loading-overlay--dark ::ng-deep .spinner-border {
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/app-common/components/loading-overlay/loading-overlay.component.scss"],"names":[],"mappings":"AAAA,6EAAA;AACA;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACJ;;AAEA;EACI,qCAAA;AACJ;;AAEA;EACI,qCAAA;AACJ;;AAEA;EACI,kCAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,yBAAA;AACJ","sourcesContent":["/* Shared absolute overlay for loading states inside positioned containers. */\n.loading-overlay {\n    position: absolute;\n    inset: 0;\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n}\n\n.loading-overlay--light {\n    background: rgba(255, 255, 255, 0.92);\n}\n\n.loading-overlay--soft {\n    background: rgba(255, 255, 255, 0.82);\n}\n\n.loading-overlay--dark {\n    background: rgba(15, 23, 42, 0.55);\n}\n\n.loading-overlay--dark ::ng-deep .loading-indicator {\n    color: #f8fafc;\n}\n\n.loading-overlay--dark ::ng-deep .spinner-border {\n    color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
